export default __webpack_public_path__ + "static/media/2117.4aed0cfb.png";